import React, { useCallback } from 'react';

import { SiteConfigManager } from '@atlas/core';
import { EmptyStateView } from '@atlas/ui';

import { GAME_SIZES } from 'components/Pages/Casino/constants';
import SearchCategoryGamesList from 'components/Pages/Casino/GameList/SearchCategoryGamesList';
import { useCasinoFilterState } from 'src/components/Pages/Casino/CasinoFilterContext';
import {
  casinoFilterTypeMap,
  deleteCasinoFilter,
  updateCasinoFilter,
} from 'src/components/Pages/Casino/useCasinoFilter';

const sliderSettings = { rows: 1, size: GAME_SIZES.SMALL };

export const CasinoRecommendedGames = ({ scrollParent, setActiveItem }) => {
  const { updateFilter } = useCasinoFilterState();
  const homePageFunctionality = SiteConfigManager.getConfig(
    'config.config.casino.mobile_home_page',
  );

  const showCategoryHandler = useCallback(
    categoryId => () => {
      if (homePageFunctionality) {
        setActiveItem(categoryId.toString());
      } else {
        updateFilter({ categories: [categoryId] });
        updateCasinoFilter(casinoFilterTypeMap.category, categoryId);
      }

      updateFilter({ providerNames: [] });
      deleteCasinoFilter(casinoFilterTypeMap.providerNames);
      scrollParent().scrollTo(0, 0);
    },
    [homePageFunctionality, scrollParent, setActiveItem, updateFilter],
  );

  return (
    <div className="casino__recommended-games">
      <EmptyStateView
        description="casino_search_no_results_recommended_games"
        title="casino_search_no_results_title"
      />
      <SearchCategoryGamesList
        showCategoryHandler={showCategoryHandler}
        sliderSettings={sliderSettings}
      />
    </div>
  );
};
